import { Link } from "react-router-dom";
import { format } from "date-fns";
import { it, enUS, fr } from "date-fns/locale";
import { ArrowRight } from "lucide-react";
import { useTranslation } from "react-i18next";

const LOCALES = { it, en: enUS, fr };

const POST_IMAGES = {
  "naturopatia-cosa-e": "https://images.pexels.com/photos/5480036/pexels-photo-5480036.jpeg",
  "massaggio-olistico-benefici": "https://images.pexels.com/photos/6628646/pexels-photo-6628646.jpeg",
  "prevenzione-stagionale": "https://images.unsplash.com/photo-1545048702-79362596cdc9?w=1200",
  "integratori-naturali-quando": "https://images.unsplash.com/photo-1471864190281-a93a3070b6de?w=1200",
};

export default function Blog() {
  const { t, i18n } = useTranslation();
  const locale = LOCALES[i18n.resolvedLanguage] || it;
  const posts = t("blog.posts", { returnObjects: true });

  return (
    <div data-testid="page-blog" className="max-w-7xl mx-auto px-5 sm:px-8 py-16 lg:py-24">
      <div className="max-w-3xl">
        <div className="label-eyebrow mb-4">{t("blog.eyebrow")}</div>
        <h1 className="font-serif text-5xl sm:text-6xl leading-[1.05] text-[#2C2F2A]">
          {t("blog.title1")} <em className="text-[#8A9A86] font-light">{t("blog.title2")}</em>.
        </h1>
        <p className="mt-8 text-lg text-[#5C6356] leading-relaxed">{t("blog.intro")}</p>
      </div>

      <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8 mt-16">
        {posts.map((p) => (
          <Link
            to={`/blog/${p.slug}`}
            key={p.id}
            data-testid={`blog-card-${p.slug}`}
            className="card-soft overflow-hidden group flex flex-col"
          >
            <div className="overflow-hidden">
              <img
                src={POST_IMAGES[p.slug]}
                alt={p.title}
                className="w-full h-56 object-cover group-hover:scale-105 transition-transform duration-700"
              />
            </div>
            <div className="p-6 flex-1 flex flex-col">
              <div className="flex items-center gap-3 text-xs label-eyebrow">
                <span>{p.category}</span>
                <span className="text-[#E6E2D8]">·</span>
                <span>{p.read_time}</span>
              </div>
              <h3 className="font-serif text-2xl mt-3 leading-tight">{p.title}</h3>
              <p className="text-sm text-[#5C6356] mt-3 flex-1">{p.excerpt}</p>
              <div className="mt-5 flex items-center justify-between">
                <span className="text-xs text-[#5C6356]">
                  {format(new Date(p.date), "d MMMM yyyy", { locale })}
                </span>
                <ArrowRight size={16} className="text-[#8A9A86] group-hover:translate-x-1 transition-transform" strokeWidth={1.5} />
              </div>
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
}
